import {MitarbeiterBase} from './mitarbeiterBase';

export class XMitarbeiterBase extends MitarbeiterBase {
  betrieblichesKompetenzniveau?: number | string;
  beruflicheStellung?: number | string;
  geschaetzterGeschlechtsneutralerGesamtVerdienst?: number;
  abweichungGeschaetzterGeschlechtsneutralerGesamtVerdienst: string;
  berechneterGesamtverdienst?: number;
  abweichungBerechneterGesamtverdienst: string;
  standardisierterGrundlohn?: number;
  standardisierteZulagen?: number;
  standardisierterDreizehnterMonatslohn?: number;
  standardisierteSonderzahlungen?: number;
}

export interface ResultDataMitarbeiter {
  id: number;
  standardisierterGesamtVerdienst?: number;
  // -------------------------------------------
  eintrittsalter?: number;
  monatslohn13VomGrundlohn?: number;
  testMonatslohn13?: boolean;
  differenzMonatslohn13?: number;
  zulagenVomGrundlohn?: number;
  testZulagen?: boolean;
  sonderzahlungenVomGrundlohn?: number;
  testSonderzahlungen?: boolean;
}

export interface ResultDataMitarbeiterM1 extends ResultDataMitarbeiter {
  geschaetzterGeschlechtsneutralerGesamtVerdienst?: number;
  abweichungGeschaetzterGeschlechtsneutralerGesamtVerdienst?: string;
  // -----------------------------------------------
  geschaetzterGesamtverdienst?: number;
  abweichungGeschaetzterGesamtverdienst?: number;
  hatValue?: number;
  cooksDistanz?: number;
  ausbildungsjahre?: number;
  potenzielleErwerbsjahre?: number;
  BKNBST?: number;
  Monatslohn13VomGrundlohn?: number;
  TestMonatslohn13?: number;
  DifferenzMonatslohn13?: number;
  ZulagenVomGrundlohn?: number;
  TestZulagen?: boolean;
  SonderzahlungenVomGrundlohn?: number;
  TestSonderzahlungen?: boolean;
}

export interface ResultDataMitarbeiterM2 extends ResultDataMitarbeiter {
  funktionswert?: number;
  rangErwartet?: number;
  rangLohn?: number;
  rangDifferenz?: number;
  // ------------------------------------------------
  funktionswertGrundlohn?: number;
  rangErwartetGrundlohn?: number;
  rangDifferenzGrundlohn?: number;
  funktionswertFix?: number;
  rangErwartetFix?: number;
  rangDifferenzFix?: number;
  abweichungGesamtscore?: number;
  effektiveAusbildung?: number;
}

export class IdLaufNummer {
  id: string;
  laufnummer: string;
  constructor(id: number, laufnummer: string) {
    this.id = id ? id.toString() : '';
    this.laufnummer = laufnummer;
  }
}

export enum MitarbeiterProperties {
  laufnummer = 0,
  alter = 1,
  alterError = 2,
  geschlecht = 3,
  dienstjahre = 4,
  ausbildung = 5,
  funktion = 6,
  betrieblichesKompetenzniveau = 7,
  beruflicheStellung = 8,
  anMonatslohnBeschaeftigungsgrad = 9,
  anStundenlohnAnzahlBezahlteStundenImReferenzmonat = 10,
  grundlohn = 11,
  zulagen = 12,
  dreizehnterMonatslohn = 13,
  sonderzahlungen = 14,
  betrieblicheWoechentlicheArbeitszeit = 15,
  sollJahresarbeitszeitImReferenzjahr = 16,
  grundgesamtheit = 17,
  bemerkungen = 18,
  zusatz1 = 19,
  zusatz2 = 20,
  zusatz3 = 21,
  zusatz4 = 22,
  zusatz5 = 23,
  summaryStatus = 24
}
